import { render, staticRenderFns } from "./KeyboardShortcutItem.vue?vue&type=template&id=2e707112&scoped=true"
import script from "./KeyboardShortcutItem.js?vue&type=script&lang=js&external"
export * from "./KeyboardShortcutItem.js?vue&type=script&lang=js&external"
import style0 from "./KeyboardShortcutItem.scss?vue&type=style&index=0&id=2e707112&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e707112",
  null
  
)

export default component.exports